var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nprogress-container'),_c('vue-page-transition',{attrs:{"name":"fade-in-right"}},[(_vm.update_avaliable)?_c('UpdateAvaliable'):_c('div',[_c('Loading'),_c('toaster'),_c('transition',{attrs:{"name":_vm.$route.transition}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }